type MoneyIconProps = {
  size?: number
}

export function MoneyIcon({ size = 24 }: MoneyIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M15.5381 12.3652C15.952 12.3655 16.2881 12.7012 16.2881 13.1152C16.2881 13.5293 15.9521 13.865 15.5381 13.8652H13.4609C13.0467 13.8652 12.7109 13.5294 12.7109 13.1152C12.711 12.701 13.0467 12.3652 13.4609 12.3652H15.5381Z" fill="currentColor" />
      <path d="M17.6143 2.67285C18.7931 2.67285 19.7489 3.62879 19.749 4.80762V15.1924C19.7489 16.3712 18.7931 17.3271 17.6143 17.3271H2.38379C1.20502 17.3271 0.249186 16.3711 0.249023 15.1924V4.80762C0.249122 3.62882 1.20498 2.6729 2.38379 2.67285H17.6143ZM1.74902 15.1924C1.74919 15.5427 2.03344 15.8271 2.38379 15.8271H17.6143C17.9646 15.8271 18.2489 15.5427 18.249 15.1924V9.01953H1.74902V15.1924ZM2.38379 4.17285C2.0334 4.1729 1.74912 4.45724 1.74902 4.80762V7.51953H18.249V4.80762C18.2489 4.45721 17.9647 4.17285 17.6143 4.17285H2.38379Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
    </svg>
  )
}
